<template>

    <trax-ui-ajax-form-in-modal :id="id" :toastr-id="toastrId" :endpoint="endpoint" 
        :props="props" :titles="titles" :form="form" :bus="bus" icons="1">

        <trax-ui-select icon="list_alt" v-model="form.type" :options="program_types_select" 
            v-show="!form.id">
        </trax-ui-select>

        <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.name"
            v-model="form.name" :error="errors.name" required="1">
        </trax-ui-input>

        <trax-ui-input type="text" icon="text_fields" rows="3" :placeholder="lang.polaris.form.description"
            v-model="form.description" :error="errors.description">
        </trax-ui-input>

        <trax-ui-select icon="cached" v-model="form.status_code" :options="status_select">
        </trax-ui-select>

        <trax-ui-select icon="insert_photo" v-model="form.background" :options="backgrounds_select" v-show="form.id">
        </trax-ui-select>

    </trax-ui-ajax-form-in-modal>
    
</template>

<script>
    export default {

        props: ['bus', 'id', 'toastrId', 'endpoint'],
    
        data: function() {
            return {
                lang: lang,
                form: {},
                errors: {},
                status_select: data.status_select,
                program_types_select: data.program_types_select,
                backgrounds_select: data.backgrounds_select,
                props: {
                    id: { source:'id' },
                    name: { source:'name' },
                    description: { source:'description' },
                    status: { source:'status', default:'draft' },
                    type: { source:'type', default: data.program_type_default },
                    background: { source:'data.background', default: 'default.jpg' }
                },
                titles: {
                    new: lang.polaris.training.new_program,
                    duplicate: lang.polaris.training.program_duplicate,
                    update: lang.polaris.training.program_update
                }
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(that.id+'-data', function(data) {
                that.form = data;
            });

            this.bus.$on(that.id+'-data-duplicate', function(data) {
                that.form = data;
                that.form.name += ' (' + lang.polaris.training.copy + ')';
                that.form.status = 'draft';
            });
        }

    }
</script>
